import React from 'react';

const AboutsUs = () => {
    return (
        <section id="about-us" className="block spacer p-top-xl">
            <div className="wrapper">
                <div className="row gutter-width-sm">
                    <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12">
                        <div className="title">
                            <h2 style={{ fontFamily: "Encode" }}>Sheana's stylish eye inspires fresh and exciting cuts and colors for her beloved clients. Clients can be assured a relaxing, individualized, and enjoyable experience at The Sapphire Studio.</h2>
                        </div>
                    </div>
                </div>

                <div className="row gutter-width-sm justify-content-end">
                    <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12">
                        <div className="description">
                            <p style={{ fontFamily: "Encode" }} >The Sapphire Studio is a private, appointment only salon, owned and operated by Sheana Helton, a licensed and insured hair stylist and makeup artist.  Sheana's expertise has allowed her to work on the sets of Dateline, ESPN, Turner Classic Movies, and other commercial endeavors. She was recently seen on local television's FOX News, Studio STL, giving makeup tips and tricks.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutsUs;
